/**
 * Buddy invite status codes and the shared tolerance for invites the backend
 * has already resolved. Used by the connections list and by the notification
 * row so both send the same code for the same intent.
 */
import type { ApiError } from '../types/api';

export const INVITE_STATUS = {
  accept: 3,
  reject: 2,
  /** Withdraw an outgoing invite before the recipient responds. */
  cancel: 4,
} as const;

/** The invite endpoint answers 200 for a request that was already handled. */
export const isAlreadyHandledInvite = (caught: unknown): boolean => {
  const body = (caught as ApiError)?.response?.data;
  const apiMessage = typeof body === 'string' ? body : (body?.message ?? '');
  const message = (apiMessage || (caught as Error)?.message || '').toLowerCase();
  return message.includes('already') || message.includes('updated');
};
